export const updateCartUI = {
    toggleButtons(status = false){
        const btn_addcart = $('.add-to-cart')
        const btn_manage_quantity = $('.manage-quantity')
        const btn_delete_home = $('.delete-from-cart')
        const btn_remove_cart = $('.remove-from-cart')
        if(status){
            btn_addcart.prop('disabled', true)
            btn_manage_quantity.prop('disabled', true)
            btn_addcart.find('.spinner').removeClass('d-none')
            btn_delete_home.find('i').addClass('d-none')
            btn_delete_home.find('span').removeClass('d-none')
            btn_remove_cart.find('span:eq(0)').addClass('d-none')
            btn_remove_cart.find('span:eq(1)').removeClass('d-none')
        }else{
            // En el home el botón sigue deshabilitado mientras la cantidad esté en 0.
            btn_addcart.each(function(){
                var cantidad_input = $(this).closest('.plato').find('input[name="cantidad"]')
                $(this).prop('disabled', cantidad_input.length > 0 && !(parseInt(cantidad_input.val()) >= 1))
            })
            btn_manage_quantity.prop('disabled', false)
            btn_addcart.find('.spinner').addClass('d-none')
            btn_delete_home.find('i').removeClass('d-none')
            btn_delete_home.find('span').addClass('d-none')
            btn_remove_cart.find('span:eq(0)').removeClass('d-none')
            btn_remove_cart.find('span:eq(1)').addClass('d-none')
        }
    },
    updateCartCount: (count) => {
        $('#cartCount').text(count);
    },
    /**
     * El botón del home guarda el hash de una línea del producto/día (la primera);
     * si ya tiene uno se conserva, para que el tacho siga apuntando a una línea viva.
     */
    addItemHash: (product_id, hash) => {
        var div_plato = $('.plato-' + product_id + ':visible');
        var btn = div_plato.find('.add-to-cart')
        if(!btn.attr('data-hash')){
            btn.attr('data-hash', hash)
        }
    },
    /**
     * Reemplaza el hash con el que devuelve el servidor (null si no quedó ninguna
     * línea del producto/día) y muestra u oculta el tacho en consecuencia.
     */
    setItemHash: (product_id, hash) => {
        var div_plato = $('.plato-' + product_id + ':visible');
        var btn = div_plato.find('.add-to-cart')
        if(hash){
            btn.attr('data-hash', hash)
            div_plato.find('.delete-from-cart').removeClass('d-none');
        }else{
            btn.attr('data-hash', null)
            div_plato.find('.delete-from-cart').addClass('d-none');
        }
    },
    showRemoveItemHome: (product_id) => {
        var div_plato = $('.plato-' + product_id + ':visible');
        div_plato.find('.delete-from-cart').removeClass('d-none');
    },
    /**
     * Badge "N en tu carrito" con el total absoluto del producto/día (todas sus
     * líneas), tal como lo devuelve el servidor.
     */
    setCartItemCount: (product_id, count) => {
        var div_plato = $('.plato-' + product_id + ':visible');
        count = parseInt(count)
        if(isNaN(count)){
            count = 0;
        }
        var div_quantity = div_plato.find('.quanty-menu')
        div_quantity.toggleClass('d-none', count === 0)
        div_quantity.find('span').html(count === 0 ? '' : count);
    },
    updateCartItem: (item) => {
        if(!item){
            return;
        }
        $('#count-' + item.hash).val(item.quantity);
    },
    /**
     * Muestra la nota de la línea, en el checkout o en "Tu combo del día" (las
     * dos llevan data-linea). Va con .text(): la escribe el cliente y no se
     * interpreta como HTML.
     */
    setNota: (hash, nota) => {
        const linea = $('[data-linea]').filter(function(){
            return $(this).attr('data-linea') === hash;
        });
        nota = nota || '';
        linea.find('.nota-plato-texto').text(nota);
        linea.find('.nota-plato').toggleClass('d-none', nota === '');
        // Sólo el texto: el botón lleva además un ícono.
        const boton = linea.find('.btn-nota').attr('data-nota', nota);
        boton.find('.btn-nota-texto').text(nota === '' ? 'Agregar nota' : 'Editar nota');
    },
    removeItem: (id) => {
        const linea = $(`#cart_${id}`);
        const combo = linea.attr('data-combo');
        const dia = linea.attr('data-dia');
        linea.remove();
        // Sin líneas, el título del combo en el checkout ("Combo 2") sobra.
        if (combo && !$(`.cart-item[data-combo="${combo}"]`).length) {
            $(`.combo-checkout-titulo[data-combo="${combo}"]`).remove();
        }
        // Lo mismo con el encabezado del día ("Miércoles 04/11").
        if (dia && !$(`.cart-item[data-dia="${dia}"]`).length) {
            $(`.dia-checkout-titulo[data-dia="${dia}"]`).remove();
        }
    },
    /**
     * Vuelve a pedir al servidor el estado del carrito y repinta lo que depende de él.
     *
     * El importe no se calcula en el navegador: sale del plan de pago (cupos/plata),
     * que sólo el servidor conoce.
     */
    refreshState: async () => {
        try {
            const response = await axios.get(route('cart.summary'));
            const data = response.data;

            $('#summaryAccordion').html(data.summary_html);
            $('#resumenPago').html(data.resumen_html);
            $('#metodosPago').toggleClass('d-none', !data.requiere_pago);
            updateCartUI.updateCartCount(data.items_count);

            const submit = $('.btn-submit');
            if(submit.length){
                submit.text(data.requiere_pago ? submit.data('label-pago') : submit.data('label-cupos'));
            }

            // Un producto dado de baja mientras el carrito estaba abierto, o el
            // carrito que se quedó sin ítems: se recarga para que el checkout muestre
            // el estado correcto en lugar de un formulario sin pedido.
            if((data.descartados && data.descartados.length) || data.items_count === 0){
                window.location.reload();
            }
        } catch (error) {
            console.error('Error al actualizar el carrito:', error);
        }
    },
    showToast: (message, bg = '#4fbe87') => {
        Toastify({
            text: message,
            duration: 3000,
            close: true,
            gravity: "top",
            position: "right",
            style: { background: bg },
        }).showToast();
    }
};
